
define(
	'TavanoTeamStaging.StickyHeader_Extension.StickyHeader'
,   [
		'jQuery'
	]
,   function (
		jQuery
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			// Scroll Settings
			var targetHeader = 'header#site-header';
			var stickyHeaderClass = 'tt-capitol-sticky-header';
			var stickyHeaderStatus = false;
			var togglePoint = 0;
			var safeTogglePoint = 5;
			var actualScollPoint = 0;
			var tabletMaxWidth = 991;

			jQuery(document).ready(function () {
				var stickyHeaderEnable = -1;

				var findStickyHeader = function () {
					stickyHeaderEnable = jQuery("header#site-header").length;
					
					if (stickyHeaderEnable > 0) {
						togglePoint = jQuery("header .header-main-wrapper").position().top; // Get top position
						jQuery("header#site-header").css({ top: '-' + togglePoint + 'px' }); // Set top position
						togglePoint = togglePoint + safeTogglePoint;
					}
				}

				// Check for open menu nav, cart, search 
				var closeMenus = function () {
					// Close Site Settings
					jQuery('.header-subheader-settings.open').removeClass('open');
				}

				var showStickyHeader = function () {
					jQuery(targetHeader).addClass(stickyHeaderClass);
					closeMenus();
					findStickyHeader();
				}

				var hideStickyHeader = function () {
					jQuery(targetHeader).removeClass(stickyHeaderClass);
					closeMenus();
				}

				// Scroll
				if (stickyHeaderEnable && window.innerWidth > tabletMaxWidth) { // Only Desktop Scroll Event	
					jQuery(window).scroll(function () {
						actualScollPoint = window.pageYOffset || document.documentElement.scrollTop;

						if (stickyHeaderEnable === -1) {
							findStickyHeader();
						} else {
							if (actualScollPoint > togglePoint) {
								if (stickyHeaderStatus === false) {
									stickyHeaderStatus = true;
									showStickyHeader();
								}
							}

							if (actualScollPoint <= safeTogglePoint) {
								if (stickyHeaderStatus === true) {
									stickyHeaderStatus = false;
									hideStickyHeader();
								}
							}
						}
					});
				}

				// Resize
				jQuery(window).resize(function () {
					if (stickyHeaderEnable === -1) {
						findStickyHeader();
					}
					
					if (stickyHeaderEnable > 0 && stickyHeaderStatus) {
						hideStickyHeader();
					}
				});
			});
		}
	};
});
